import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import { DATE_FORMAT } from 'v2/core/date/date';
import { DateTimeRange } from '../../types';

export function getCalendarLabelByMode(
  dateRange: DateRange<dayjs.Dayjs | null>,
  timeRange: DateTimeRange | null,
  defaultLabel: string = '',
): string {
  const [from, to] = dateRange;

  if (from == null || to == null || timeRange == null) {
    return defaultLabel;
  }

  if ('last' === timeRange.type) {
    return `Last ${timeRange.value} ${timeRange.unit}${
      (timeRange.value ?? 0) > 1 ? 's' : ''
    }`;
  }

  if ('since' === timeRange.type) {
    return `Since ${from.tz().format(DATE_FORMAT)}`;
  }

  return `${from.tz().format(DATE_FORMAT)} - ${to.tz().format(DATE_FORMAT)}`;
}
